import React from 'react';
import Button from '@material-ui/core/Button';

interface Props {
  className?: string;
  sort: string;
  latest: () => void;
  relevance: () => void;
  clickCancle: () => void;
}

const SearchBarButton: React.FC<Props> = React.memo(
  ({ className, sort, latest, relevance, clickCancle }) => {
    return (
      <div className="flex justify-between font">
        <div>
          <Button
            style={{
              color: `${sort === 'date' ? '#818cf8' : 'black'}`,
            }}
            onClick={() => latest()}>
            {sort === 'date' ? <b>최신순</b> : '최신순'}
          </Button>
          <Button
            style={{
              color: `${sort === 'sim' ? '#818cf8' : 'black'}`,
            }}
            onClick={() => relevance()}>
            {sort === 'sim' ? <b>관련도순</b> : '관련도순'}
          </Button>
        </div>
        <div>
          <Button onClick={() => clickCancle()}>닫기</Button>
        </div>
      </div>
    );
  },
);

export default SearchBarButton;
